<template>
  <div class="map-placeholder ml-n3 mr-n3" :class="{ sparkasse }" aria-describedby="google-map-desc-text">
    <div class="container">
      <span id="google-map-desc-text" class="sr-only visually-hidden">
        <translate key="google-map-desc">
          This map displays project locations. Use the zoom slider to adjust the view. Alternatively, you can use search
          bar to find specific projects based on their title, location or organisation.
        </translate>
      </span>
      <div class="row h-100 align-items-center justify-content-md-center">
        <div class="col-md-8 col-12 text-center text-white">
          <div>
            <h2><translate>Project map not active</translate></h2>
          </div>

          <!--
            Warning:
            Vue (at least I think it happens within Vue's rendering) reorders a-tags,
            so don't change the order, or it will break translations :'(
          -->
          <div
            v-translate="{ platformOperatorName: platformOperator, privacyPolicyURL: platformPrivacyPolicyLink }"
            render-html="true"
          >
            If you activate the project map by clicking on the button below, you agree to
            <strong>%{ platformOperatorName }</strong> that personal data (e.g. IP address) will be transmitted to
            Google Ireland Limited as the provider of the service and may also be processed on servers in the USA. You
            can revoke your consent at any time via the
            <a href="/cookie-settings" target="_blank" class="text-white">cookie settings</a>. Further information on
            data protection can be found <a href="%{ privacyPolicyURL }" target="_blank" class="text-white">here</a>.
          </div>
          <div class="text-center padding-10">
            <b-button variant="base-ci" @click="onClickCookieButton">
              <translate>Activate project map</translate>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import { setCookie } from '@/utils/helpers'

@Component({
  name: 'map-placeholder',
})
export default class MapPlaceholder extends Vue {
  @Prop({ default: false }) sparkasse: boolean
  @Prop({ default: '' }) platformOperator: string
  @Prop({ default: '' }) platformPrivacyPolicyLink: string

  COOKIE_NAME = 'cookie_rule_detail'
  REQUIRED_COOKIE_VALUE = 'google-maps'

  get cookieRuleDetail(): string {
    return this.$cookies.get(this.COOKIE_NAME)
  }

  setCookieRuleDetail(): void {
    if (this.cookieRuleDetail) {
      // The vue-cookies library doesn't provide the underlying setRaw function, so we have to do it ourselves.
      // this.$cookies.set would encode the comma, which other parts of the application expect to be unencoded
      setCookie(this.COOKIE_NAME, `${this.cookieRuleDetail},${this.REQUIRED_COOKIE_VALUE}`)
    } else {
      this.$cookies.set(this.COOKIE_NAME, this.REQUIRED_COOKIE_VALUE)
    }
  }

  onClickCookieButton() {
    this.setCookieRuleDetail()
    window.location.reload()
  }
}
</script>
